import { render, staticRenderFns } from "./DocumentInsure.vue?vue&type=template&id=ce1fd740&scoped=true"
import script from "./DocumentInsure.vue?vue&type=script&lang=js"
export * from "./DocumentInsure.vue?vue&type=script&lang=js"
import style0 from "./DocumentInsure.vue?vue&type=style&index=0&id=ce1fd740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1fd740",
  null
  
)

export default component.exports